export interface ProfessionalsState {
  professionals: [] | null
}

export const professionalsMutationTypes = {
  FETCH_PROFESSIONALS: 'FETCH_PROFESSIONALS'
}
